module.exports = __webpack_public_path__ + "img/T912.f58bf2f7.jpg";